import React, { useState } from 'react';
import './AssuranceChoice.scss';
import { usePickerContext } from "../../picker/hooks/usePickerContext";

export function AssuranceChoice({ assurances, onAssuranceChange }) {
    const { state } = usePickerContext();
    const [selectedAssurance, setSelectedAssurance] = useState(null);

    const handleCheckboxChange = (key) => {
        setSelectedAssurance(key);
        const selectedData = assurances[key];
        selectedData.key = key;
        if (onAssuranceChange) {
            onAssuranceChange(selectedData); // Appel correct de la fonction
        }
    };

    const getSymbol = (modeCalcul) => {
        return modeCalcul === 'P' ? '%' : '€';
    };

    return (
        <tbody>
        {Object.keys(assurances).map((key) => (
            <tr key={key}>
                <td colSpan={3}>
                    <label>
                        <input
                            type="radio"
                            checked={selectedAssurance === key}
                            onChange={() => handleCheckboxChange(key)}
                        />
                        {assurances[key].label}
                    </label>
                </td>
                <td>
                    <p><strong>{assurances[key].pvente} {getSymbol(assurances[key].modeCalcul)}</strong></p>
                </td>
                <td>
                    <div className="tooltip-container">
                        <span className="tooltip-icon">ℹ️</span>
                        <span className="tooltip-text"dangerouslySetInnerHTML={{ __html: assurances[key].descriptif }}></span>
                    </div>
                </td>
            </tr>
        ))}
        </tbody>
    );
}